import PropTypes from 'prop-types';
import { useEffect } from 'react';

import SerialFormatterSection from '#/modules/imsMgmt/settings/mtrTemplate/components/SerialFormatterSection';
import useMtrSerialFormatter from '#/modules/imsMgmt/settings/mtrTemplate/hooks/useMtrSerialFormatter';

const MtrSerialFormatterField = ({
  setValue,
  errors,
  resetKey,
  initialRaw,
  mtrStructMainId,
  mtrStructSubId,
  specs,
  specOptions,
  structMainOptions,
  structSubOptions,
  onSeedReady,
}) => {
  const serialFormatter = useMtrSerialFormatter({
    setValue,
    initialRaw,
    mtrStructMainId,
    mtrStructSubId,
    specs,
    specOptions,
    structMainOptions,
    structSubOptions,
  });

  useEffect(() => {
    if (!onSeedReady) {
      return;
    }

    onSeedReady(serialFormatter.trySeedDefaults);
  }, [onSeedReady, resetKey, serialFormatter.trySeedDefaults]);

  return (
    <SerialFormatterSection
      errors={errors}
      items={serialFormatter.items}
      sourceOptions={serialFormatter.sourceOptions}
      availableSourceOptions={serialFormatter.availableSourceOptions}
      addSourceItem={serialFormatter.addSourceItem}
      addCustomItem={serialFormatter.addCustomItem}
      removeItem={serialFormatter.removeItem}
      reorderItems={serialFormatter.reorderItems}
    />
  );
};

MtrSerialFormatterField.propTypes = {
  setValue: PropTypes.func.isRequired,
  errors: PropTypes.object,
  resetKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  initialRaw: PropTypes.string,
  mtrStructMainId: PropTypes.string,
  mtrStructSubId: PropTypes.string,
  specs: PropTypes.array,
  specOptions: PropTypes.array.isRequired,
  structMainOptions: PropTypes.array.isRequired,
  structSubOptions: PropTypes.array.isRequired,
  onSeedReady: PropTypes.func,
};

export default MtrSerialFormatterField;
